module.exports = __webpack_public_path__ + "static/media/car-2.1b7fb31f.png";